import { Sensor } from "./Sensor";
import { SensorHistory } from "./SensorHistory";
import * as Utils from "../utils";

export const clearOldData = async (): Promise<void> => {
	const sensorTable = new Sensor();
	const currentTime = Utils.time.current();
	const sensors = await sensorTable.getAll();

	for (const sensor of sensors) {
		if (sensor.id) {
			if (!!sensor.lastUsage && currentTime - sensor.lastUsage > Utils.time.MILLISECONDS_OF_4WEEK) {
				const [shipmentId, deviceId, sensorDBKey] = sensor.id.split("#");
				const historyKeys = await new SensorHistory().getAllKeys(shipmentId, deviceId, sensorDBKey);
				for (const key of historyKeys) {
					await new SensorHistory().delete(key);
				}
				await sensorTable.delete(sensor.id);
			}
		}
	}
};

export const clearCacheData = async () => {
	const sensorTable = new Sensor();
	const sensorHistoryTable =  new SensorHistory();
	await sensorTable.clearObjectStore();
	await sensorHistoryTable.clearObjectStore();
}
